module.exports = __webpack_public_path__ + "static/dy-2ef6bb50a8aa863ebb7e858bf1ae7017.png";